import styled from 'styled-components';
import { breakText } from 'app/utils/styles/Common';

const Text = styled.span`
    font-size: inherit;
    overflow: hidden;
    ${breakText}
`;

export default Text;
